// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 746 ? "pages-" : chunkId) + "." + {"490":"c5af44e7","564":"ed51dadf","746":"7d9f8f1f"}[chunkId] + ".chunk.js";
};